import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/immersive`;

export const Immersive = {
  experiences: () => axios.get(`${API}/experiences`).then((r) => r.data),
  experience: (slug) => axios.get(`${API}/experience/${slug}`).then((r) => r.data),
  submitAssessment: (experience, answers, session_id) =>
    axios
      .post(`${API}/assessment/submit`, { experience, answers, session_id })
      .then((r) => r.data),
  event: (event, payload = {}) =>
    axios
      .post(`${API}/event`, { event, ...payload })
      .then((r) => r.data)
      .catch(() => null),
};

const LS = "edusphere_immersive_session_v1";
export function immersiveSession() {
  let s = localStorage.getItem(LS);
  if (!s) {
    s = `imm_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 8)}`;
    localStorage.setItem(LS, s);
  }
  return s;
}
